import { useCallback } from 'react';

import { useSetState } from './use-set-state.js';
import type { Point } from '../../../../core/types/point.js';

export const useSetTooltipState = () => {
  const setState = useSetState();

  const setTooltipStatePosition = useCallback(
    (position: Point) => setState((prev) => ({ ...prev, position })),
    [setState],
  );

  const setTooltipStateVisibility = useCallback(
    (visible: boolean) =>
      setState((prev) => {
        if (prev.visible === visible) {
          return prev;
        }

        return { ...prev, visible };
      }),
    [setState],
  );

  const setTooltipStateHidden = useCallback(
    () =>
      setState((prev) => {
        if (!prev.pinned) {
          return prev;
        }

        return {
          position: { x: 0, y: 0 },
          pinned: false,
          visible: false,
        };
      }),
    [setState],
  );

  const toggleTooltipStatePinned = useCallback(
    () => setState((prev) => ({ ...prev, pinned: !prev.pinned })),
    [setState],
  );

  return {
    setTooltipStatePosition,
    setTooltipStateVisibility,
    toggleTooltipStatePinned,
    setTooltipStateHidden,
  };
};
